import $ from 'jquery';

const eventImgPreview = (function () {
  function _init() {
    const imgPreviewFunction = () => {
      document.querySelectorAll('.js-evenement-item__img-wrap').forEach(s => {
        let i = 0
          , a = 0
          , l = 0
          , c = 0;
        const d = .1,
          parent = s.closest('.js-evenements-wrapper');

        function w() {
          const y = i - l
            , g = a - c;
          l += y * d,
            c += g * d,
            s.style.left = `${l}px`,
            s.style.top = `${c}px`,
            requestAnimationFrame(w)
        }

        w(),
          parent.addEventListener('mousemove', function (y) {
            i = y.clientX,
              a = y.clientY
          })
      });
    }

    imgPreviewFunction();

    const radioFilter = $('.form-radio', '.js-evenements-wrapper');
    if (radioFilter) {
      $(document).on('change', radioFilter, function () {
        setTimeout(function () {
          imgPreviewFunction();
        }, 1000);
      });
    }

  }
  return {init: _init};
})();

export default eventImgPreview;
